import Contact from "../about/Contact";
import { Features, WorkSteps } from "../../constants/ServiceDetailsConstant";
import { useParams } from "react-router-dom";
import { SERVICE_DATA } from "../../constants/ServiceConstant";
import BreadCrumbs from "../../common/BreadCrumbs";
import Accordion from "../../common/Accordion";
import FeaturesSvg from "../../common/svg/FeaturesSvg";
import { useEffect } from "react";

const ServiceDetails = ({
  setTab,
}: {
  setTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  useEffect(() => {
    setTab("services");
  }, [setTab]);
  const { serviceId } = useParams<{ serviceId: string }>();
  const currentService =
    SERVICE_DATA.filter((item) => item.id === serviceId)?.[0] || {};

  if (!currentService) {
    return <p>Service not found</p>;
  }

  return (
    <>
      <BreadCrumbs title="Services" description={currentService.title} />
      <div className="service-details ">
        {/* About Section */}
        <div className="about-services sec-mar">
          <div className="container">
            <div className="row gy-5">
              <div
                className="col-lg-6 d-flex align-items-center wow animate__animated animate__fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className="about-content">
                  <div className="section-title-5">
                    <h2> {currentService.title || "Service Details"} </h2>
                  </div>
                  <p> {currentService.description} </p>
                  <ul className="about-featue">
                    {Features.map((item, index) => (
                      <li key={index}>
                        <FeaturesSvg /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-6 wow animate__animated animate__fadeInRight"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <div className="service-img magnetic-item">
                  <img
                    className="img-fluid"
                    src={currentService.img}
                    alt={currentService.imgAlt}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* How We Work Section */}
        <div className="how-we-work-section sec-mar">
          <div className="container">
            <div
              className="row mb-60 wow animate__animated animate__fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>How we work</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="work-item">
            <div className="container-fluid">
              <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 gy-5 justify-content-center">
                {WorkSteps.map((step, index) => (
                  <div
                    key={index}
                    className="col magnetic-item wow animate__animated animate__fadeInUp"
                    data-wow-delay={step.delay}
                    data-wow-duration="1500ms"
                  >
                    <div className="single-work">
                      <div className="work-icon">
                        <img src={step.icon} alt="" />
                      </div>
                      <div className="work-content">
                        <h3>{step.title}.</h3>
                        <p> {step.text} </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Description section */}
        <div className="service-sort-driscription-area sec-mar">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-12 wow animate__animated animate__fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className="driscription-img magnetic-item">
                  <img
                    className="img-fluid"
                    src={currentService.descImage}
                    alt="Description"
                  />
                </div>
              </div>
              <div className="driscription-content">
                <div className="row">
                  {currentService.descriptionParagraphs.map((text, index) => (
                    <div
                      key={index}
                      className="col-md-6 wow animate__animated animate__fadeInUp"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      <p dangerouslySetInnerHTML={{ __html: text }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FAQ Section */}
        <div className="service-faq-area sec-mar">
          <div className="container">
            <div className="row gy-5">
              <div
                className="col-lg-6 wow animate__animated animate__fadeInLeft"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className="faq-img magnetic-item">
                  <img
                    className="img-fluid"
                    src={currentService.faqImage}
                    alt="faq"
                  />
                </div>
              </div>
              <div
                className="col-lg-6 d-flex align-items-center wow animate__animated animate__fadeInRight"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <div className="faq-content-area">
                  <h2> {currentService.faqTitle} </h2>
                  {/* Accordian*/}
                  <Accordion data={currentService.faqs} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </>
  );
};

export default ServiceDetails;
